import * as Sentry from '@sentry/react'

import { noop } from '../../utils/functions'
import { Consts } from '../consts'

export function setupSentry(opts: Sentry.BrowserOptions & { version: string }) {
  const config: Sentry.BrowserOptions = {
    dsn: 'https://32765e1e82fd9f4dca589d1331a1430a@o4508509225746432.ingest.us.sentry.io/4508509228630016',
    debug: Consts.isDev,
    release: opts.version,
    environment: Consts.env,
    enabled: Consts.isProd,
    normalizeDepth: 10,
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click') {
        const target = hint?.event.target

        if ('innerText' in target && !!target.innerText?.trim()?.length) {
          breadcrumb.message = target.innerText
        }
      }

      return breadcrumb
    },
    ...opts,
  }

  if (config.debug) {
    console.info('Sentry config:', config)
  }

  Sentry.init(config)
}

export function sentrySetUser(user: Sentry.User | null) {
  Sentry.setUser(user)
}

export function sentryCaptureException(error: any) {
  Sentry.captureException(error)
}

export const sentryNavigationIntegration = {
  registerNavigationContainer: noop,
}

export const sentryAddBreadcrumb = Sentry.addBreadcrumb
